import { createTheme } from "@mantine/core"

export const theme = createTheme({
  colorScheme: "light",
  primaryColor: "brand",
  colors: {
    // Our brand blue colors
    brand: [
      "#e8f4f8", // Very light blue (used in backgrounds)
      "#d0eeff", // Light blue (used in header background)
      "#90caf9", // Lighter blue
      "#64b5f6", // Medium light blue
      "#42a5f5", // Medium blue
      "#2196f3", // Standard blue
      "#1e88e5", // Medium dark blue
      "#015ab9", // Our main brand blue
      "#1565c0", // Darker blue
      "#0d47a1", // Very dark blue
    ],
    // Success/positive colors
    success: [
      "#e8f5e8",
      "#c8e6c8",
      "#a5d6a5",
      "#81c784",
      "#66bb6a",
      "#4caf50",
      "#43a047",
      "#28a745", // Our success green
      "#2e7d32",
      "#1b5e20",
    ],
    // Error/warning colors
    error: [
      "#ffebee",
      "#ffcdd2",
      "#ef9a9a",
      "#e57373",
      "#ef5350",
      "#f44336",
      "#e53935",
      "#dc3545", // Our error red
      "#c62828",
      "#b71c1c",
    ],
    // Neutral grays
    neutral: [
      "#ffffff", // White
      "#f8f9fa", // Very light gray (used in backgrounds)
      "#e9ecef", // Light gray (used in borders)
      "#dee2e6", // Medium light gray
      "#ced4da", // Medium gray
      "#adb5bd", // Medium dark gray
      "#6c757d", // Dark gray (used for dimmed text)
      "#495057", // Very dark gray
      "#343a40", // Almost black
      "#212529", // Black
    ],
  },
  fontFamily:
    "'Archivo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  headings: {
    fontFamily:
      "'Archivo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 600,
  },
  spacing: {
    xs: "0.625rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem",
  },
  radius: {
    xs: "0.125rem",
    sm: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
  },
  other: {
    // Custom theme values for specific use cases
    brandBlue: "#015ab9",
    headerBg: "#d0eeff",
    lightBg: "#f8f9fa",
    dimmedText: "#6c757d",
    successGreen: "#28a745",
    errorRed: "#dc3545",
    borderColor: "#e9ecef",
  },
})
